import {
    buildActionCreators,
    makeActionTypes,
    makeAsyncEvents,
    namedParameters,
    noParameters,
} from '/b2b/common/helpers/ReduxHelpers';

import { DOMAIN } from './AuthCustomerDSARForms.constants';

export const events = {
    openAddDialog: noParameters,
    closeAddDialog: noParameters,
    closeDeleteDialog: noParameters,
    openDeleteDialog: noParameters,
    addFilter: namedParameters('field', 'value'),
    removeFilter: namedParameters('field', 'value'),
    setFilter: namedParameters('field', 'value'),
    clearFilter: namedParameters('field'),
    assignFilters: namedParameters('value'),
    resetFilters: noParameters,
};

export const asyncEvents = makeAsyncEvents(['fetchResults'], true);
export const crudEvents = makeAsyncEvents(['create', 'update', 'delete'], true);

export const types = makeActionTypes(
    [...Object.keys(events), ...Object.keys(asyncEvents), ...Object.keys(crudEvents)],
    DOMAIN
);

export default buildActionCreators(
    {
        ...events,
        ...asyncEvents,
        ...crudEvents,
    },
    types
);
